import React from "react";
import Helmet from "react-helmet";

interface PlausibleScriptProps {
  performanceCookieConsent: boolean;
}

const PlausibleScript: React.FC<PlausibleScriptProps> = ({ performanceCookieConsent }) => {
  const isProd = process.env.GATSBY_ENV === "production";

  if (!isProd || !performanceCookieConsent) return null;

  return (
    <Helmet>
      <script
        defer
        data-domain="classdojo.com"
        src="https://plausible.classdojo-ops.com/js/script.file-downloads.hash.outbound-links.pageview-props.revenue.tagged-events.js"
      ></script>
      <script>{`
          window.plausible = window.plausible || function() {
            (window.plausible.q = window.plausible.q || []).push(arguments)
          }
      `}</script>
    </Helmet>
  );
};

export default PlausibleScript;
